export default __webpack_public_path__ + "static/media/test3.63a7f1f4.jpg";